import type { ContextSearchPlace } from '@web-platform/shared-universal-types/src/context';
import type { SearchLegPlace } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';
import type { EntityId, Nullable } from '@web-platform/shared-universal-types-utils/src/utils';

export const getEntityId = (
  searchPlace: SearchLegPlace | ContextSearchPlace | undefined,
): Nullable<EntityId> | undefined => {
  const { entityId: placeEntityId, geoContainerId, geoId, travelEntityId } = searchPlace || {};
  return geoId || geoContainerId || travelEntityId || placeEntityId;
};
